import {
  XMarkIcon,
  Bars3BottomLeftIcon,
  UserIcon,
  ArrowLeftEndOnRectangleIcon,
} from "@heroicons/react/24/outline";
import logo from "../../../../assest/images/logo.png";
import { useSidebarStatus } from "../../../context/SideBarStatusContext";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from "@headlessui/react";
import { useAuth } from "../../../context/AuthContext";
import { useMutation } from "react-query";
import axios from "axios";
import { BASEURL } from "../../../../utils/BaseUrl";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import SpinerLoading from "../../../../common/Loading/SpinerLoading";
import TraingleLoading from "../../../../common/Loading/TraingleLoading";
import { BsArrowsFullscreen } from "react-icons/bs";
export default function AdminHeader() {
  const { isSidebarOpen, setSidebarOpen } = useSidebarStatus();
  const { currentUser, token, setToken } = useAuth();
  const navigate = useNavigate();

  const toggleFullScreen = () => {
    if (
      !document.fullscreenElement && // Check if the page is not in fullscreen
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      // Enter Fullscreen for modern browsers
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        // Firefox
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        // Chrome, Safari, Opera
        document.documentElement.webkitRequestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        // IE/Edge
        document.documentElement.msRequestFullscreen();
      }
    } else {
      // Exit Fullscreen
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        // Firefox
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        // Chrome, Safari, Opera
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        // IE/Edge
        document.msExitFullscreen();
      }
    }
  };

  const mutation = useMutation({
    mutationFn: (values) => {
      return axios.post(`${BASEURL}logout`, values).then((res) => {
        localStorage.clear();
        navigate("/admin");
      });
    },
  });
  const handleLogout = (e) => {
    e.preventDefault();
    mutation.mutate({ refreshToken: token?.refresh_token });
  };

  useEffect(() => {
    if (mutation?.isSuccess) {
      setToken("");
      localStorage.clear();
      navigate("/admin");
    }
  }, [mutation]);

  return (
    <div className="flex justify-between items-center px-4 admin-header ">
      {mutation.isLoading && <TraingleLoading />}
      <div className="flex items-center ">
        <div>
          <Bars3BottomLeftIcon
            onClick={() => setSidebarOpen(!isSidebarOpen)}
            className="w-10 h-10 admin-header-icon"
            style={{ cursor: "pointer" }}
          />
        </div>
        <div className="adminHeader-logo">
          <img alt="Your Company" src={logo} className="w-8 h-8" />
          <h1>Aswin cold Forge</h1>
        </div>
      </div>
      <div className="relative flex items-center">
        <div className="mr-4">
          <BsArrowsFullscreen
            className="w-6 h-6 text-white"
            onClick={toggleFullScreen}
          />
        </div>
        <Menu as="div" className="relative ml-3">
          <div>
            <MenuButton className="relative flex rounded-full admin-header-icon2 text-sm  border p-1 ">
              <span className="absolute -inset-1.5" />
              <span className="sr-only">Open user menu</span>

              <UserIcon className="w-8 h-8 admin-header-icon cursor-pointer" />
            </MenuButton>
          </div>
          <MenuItems
            transition
            className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
          >
            <MenuItem>
              <div className="adminmenu ">
                <UserIcon className="w-6 h-6  text-black mr-2  " />
                <span>{_.capitalize(currentUser?.username)}</span>
              </div>
            </MenuItem>

            <MenuItem>
              <div onClick={(e) => handleLogout(e)} className=" adminmenu ">
                <ArrowLeftEndOnRectangleIcon className="w-6 h-6 text-black mr-2 " />
                <span>Log out</span>
              </div>
            </MenuItem>
          </MenuItems>
        </Menu>
      </div>
    </div>
  );
}
